import type { Locale } from '@/i18n/locale.ts'
import { en, type Messages } from '@/i18n/messages/en/index.ts'
import { ptBR } from '@/i18n/messages/pt-BR/index.ts'

export type { Messages }
export { en, ptBR }

/**
 * Both catalogues, keyed by locale. `Record<Locale, Messages>` is what makes adding a third
 * language a compile error until its catalogue exists, rather than a runtime surprise.
 */
export const catalogs: Record<Locale, Messages> = {
  en,
  'pt-BR': ptBR
}
